import React, {Component} from 'react';
import {
    Input,
    Label,
    Col,
    FormGroup,
    Form,
    Button,
    FormFeedback
} from 'reactstrap';
import _ from 'lodash';
import './BusinessAmbassadorDetails.css';
import PropTypes from 'prop-types';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import {Redirect} from "react-router-dom";
import {Utils} from "../../../utils/utils";

export const ACTION_TYPES = {
    ADD: 'add',
    EDIT: 'edit'
};

const fields = ['firstName', 'lastName', 'email', 'phoneNumber', 'financialData', 'balanceCurrency'];

class BusinessAmbassadorDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            financialData: '',
            balanceCurrency: 'USD'
        };
    }

    componentWillMount() {
        if (this.props.actionType === ACTION_TYPES.EDIT && !_.isNil(this.props.id)) {
            this.props.onMount(this.props.id);
        }

        if (!_.isNil(this.props.data)) {
            this.setState({
                firstName: this.props.data.firstName,
                lastName: this.props.data.lastName,
                email: this.props.data.email || '',
                phoneNumber: this.props.data.phoneNumber || '',
                financialData: this.props.data.financialData,
                balanceCurrency: this.props.data.balance.currency
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (_.isNil(this.props.data) && !_.isNil(nextProps.data)) {
            this.setState({
                firstName: nextProps.data.firstName,
                lastName: nextProps.data.lastName,
                email: nextProps.data.email || '',
                phoneNumber: nextProps.data.phoneNumber || '',
                financialData: nextProps.data.financialData,
                balanceCurrency: nextProps.data.balance.currency
            });
        }
    }

    render() {
        if (this.props.success) {
            return <Redirect to='/business-ambassadors' push />
        }

        return (
            <div className='ba-details-container'>
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'business_ambassadors.' + this.props.actionType + '_business_ambassador_success_message')}>
                    <BackButtonComponent path='/business-ambassadors'
                                         label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className='ba-form-container'>
                        <h4 className='page-label'>{_.get(this.props.translation, 'business_ambassadors.' + this.props.actionType + '_business_ambassador_label')}</h4>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        return (
            <Form className='self-study-book-form' onSubmit={this.handleSubmit}>
                {this.renderFormGroups()}
                {this.renderCurrencyFormGroup()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn" disabled={this.saveButtonDisabled()}>
                        {_.get(this.props.translation, this.props.actionType === ACTION_TYPES.ADD ? sharedLabelsPath.add_button : sharedLabelsPath.save_changes_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    saveButtonDisabled = () => {
        if (this.props.actionType === ACTION_TYPES.ADD) {
            return false;
        }

        if (_.isNil(this.props.data)) {
            return true;
        }

        return _.every(fields, field =>
            this.props.data.hasOwnProperty(field) ? this.props.data[field] === this.state[field] : this.state[field] === ''
        );
    };

    renderFormGroups = () => {
        let paramsList = [
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            },
            {
                value: "email",
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label),
                placeholder: _.get(this.props.translation, sharedLabelsPath.phone_number_label)
            },
            {
                value: "financialData",
                type: 'textarea',
                title: _.get(this.props.translation, 'business_ambassadors.financial_data_label'),
                isRequired: true,
                placeholder: _.get(this.props.translation, 'business_ambassadors.financial_data_label')
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)]
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={_.get(this.state, params.value)}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}>
                        {params.content}
                    </Input>
                    <FormFeedback>{params.errorMessage || ''}</FormFeedback>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            selectedOption={_.find(params.content, option => option.value === this.state[params.value])}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    renderCurrencyFormGroup = () => {
        return (
            <FormGroup row>
                <Label for="balance-currency-select" sm={3}>{_.get(this.props.translation, "finance.balance_currency_label") + "*"}</Label>
                <Col sm={9}>
                    <Select id="balance-currency-select"
                            selectedOption={_.find(Utils.getCurrenciesOptions(this.props.currenciesData), option =>
                                option.value === this.state.balanceCurrency)}
                            options={Utils.getCurrenciesOptions(this.props.currenciesData)}
                            onSelect={this.handleChangeSelect("balanceCurrency")}
                            requiredFieldError={this.state.requiredFieldError === "balanceCurrency"}
                    />
                </Col>
            </FormGroup>
        )
    }

    handleChangeSelect = (fieldName) => (selectedOption) => {
        this.setState({[fieldName]: selectedOption.value});
    };

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let data = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            financialData: this.state.financialData,
            balance: {
                amount: 0,
                currency: this.state.balanceCurrency
            }
        };

        if (this.state.email) {
            data.email = this.state.email;
        }
        if (this.state.phoneNumber) {
            data.phoneNumber = this.state.phoneNumber;
        }

        switch (this.props.actionType) {
            case ACTION_TYPES.ADD:
                this.props.onProcess(data);
                break;
            case ACTION_TYPES.EDIT:
                this.props.onProcess(this.props.id, data);
                break;
            default:
                break;
        }
    };
}

BusinessAmbassadorDetails.propTypes = {
    id: PropTypes.string,
    data: PropTypes.object,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    actionType: PropTypes.string.isRequired,
    success: PropTypes.bool,
    currenciesData: PropTypes.array,
    onProcess: PropTypes.func.isRequired,
    onMount: PropTypes.func
};

export default BusinessAmbassadorDetails;



// WEBPACK FOOTER //
// ./src/components/businessAmbassadorsManagement/businessAmbassadorDetails/BusinessAmbassadorDetails.js